module.exports = __webpack_public_path__ + "img/logo.ef8c52bb.svg";